'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const useClickOutside = ({ onClickOutside, events = ["click", "touchend"] }) => {
  const [node, setNode] = React.useState(null);
  React.useEffect(() => {
    const onClick = (event) => {
      if (node && !node.contains(event.target)) {
        onClickOutside(event);
      }
    };
    const body = document && document.body;
    if (body) {
      for (const event of events) {
        body.addEventListener(event, onClick, { capture: true });
      }
      return () => {
        for (const event of events) {
          body.removeEventListener(event, onClick, { capture: true });
        }
      };
    }
    return () => {
    };
  }, [node, onClickOutside, events]);
  return [setNode];
};

exports.useClickOutside = useClickOutside;
//# sourceMappingURL=useClickOutside.cjs.js.map
